
import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarMenu, 
  SidebarMenuButton, 
  SidebarMenuItem,
  useSidebar 
} from '@/components/ui/sidebar';
import { Home, MessageSquare, Award, BookOpen, Bell, Brain, Database, Terminal } from 'lucide-react';
import { useSidebarNavigation } from '@/hooks/useSidebarNavigation';

const mainNavItems = [
  { title: "Dashboard", url: "/dashboard", icon: Home },
  { title: "AI Tutor", url: "/ai-tutor", icon: Brain },
  { title: "SQL Playground", url: "/sql-playground", icon: Database },
  { title: "Node.js Labs", url: "/webcontainer-demo", icon: Terminal },
  { title: "Advanced Features", url: "/advanced-features", icon: BookOpen },
  { title: "Certificates", url: "/certificates", icon: Award },
  { title: "Notifications", url: "/notifications", icon: Bell },
];

export const MainNavigationSection = () => {
  const { state } = useSidebar();
  const { isActive } = useSidebarNavigation();

  const getNavClass = (path: string) => 
    isActive(path) ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-100 font-medium" : "hover:bg-muted/50";

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          {mainNavItems.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton asChild>
                <NavLink to={item.url} className={getNavClass(item.url)}>
                  <item.icon className="h-4 w-4" />
                  {state !== "collapsed" && <span>{item.title}</span>}
                </NavLink>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
